import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function useVPAccordion(transNamespace: string) {
  const { t } = useTranslation(transNamespace, { keyPrefix: 'OrderSummary' });

  return useMemo(
    () => [
      {
        fields: [
          {
            accessor: 'packagedItemDescription',
          },
          {
            label: t('fields.referenceCode'),
            accessor: 'packagedItemReference',
          },
        ],
      },
      {
        fields: [
          {
            label: t('fields.packSize'),
            accessor: 'packageDescription',
          },
          {
            label: t('fields.packNumber'),
            accessor: 'packagedItemQty',
          },
        ],
      },
    ],
    [t],
  );
}
